import { POST } from '@/api'

const DEFAULT_TOS = {
  jp:
    '▽ご希望のご予約日時、人数で予約ができない場合\n-画面上で選択ができないご予約日時でも、お電話をいただければお席をご用意できる場合がございます。\n画面上で予約ができなかった場合、XX-XXXX-XXXXまでお電話ください。\n\n▽人数の変更について\n-ご予約人数を変更される場合は、ご予約日●日前の●時までにご連絡ください。\n規定の時間を越えてからの変更は、お料理分のキャンセル料金を請求させていただきます。\n\n▽事前キャンセルについて\n-ご予約をキャンセルされる場合は、ご予約日●日前の●時までにご連絡ください。\n規定の時間を越えてからのキャンセルはキャンセル料を請求させていただきます。\n\n▽無断キャンセルについて\n-無断キャンセルされた場合、キャンセル料を請求させていただきます。\n-無断キャンセルされた場合、次回以降のご予約をお断りさせていただく場合がございます。\nご了承ください。\n\n▽その他\n-ご予約時間を15分すぎても、ご連絡なくご来店いただけなかった場合、キャンセルとさせていただきます。\nご了承ください。\n-1名様につき、1ドリンク、1フードのご注文をお願いしております。\n-デザートのみのご予約は承っておりません。ご了承ください。\n-ご予約当日にご予約された人数以上のお客様でご来店された場合、お席のご用意ができない場合があります。ご了承ください。\n-混雑している場合、お席のご利用時間を●時間までとさせていただく場合があります。ご了承ください。',
  en:
    'If you can not make a reservation on the desired date and time, or if you can not make a reservation on the desired number of people,\nYou may be able to prepare your seat by phone.\nPlease call XX-XXXX-XXXX if you like.\n\nIf you would like to change the number of guests, please contact us at least ● days before the reservation date.\nIf you change after the specified time, you will be charged a cancellation fee for the food.\n\nTo cancel your reservation, please contact us at least ● days prior to your reservation date.\nCancellations beyond the stipulated time will be charged a cancellation fee.\n\nIf canceled without notice, a cancellation fee will be charged.\nIf canceled without notice, we may refuse to make your next reservation. Please note.\n\nIf you do not get in touch with us even if your reservation time is over 15 minutes, we will cancel it. Please note.\nPlease order 1 drink and 1 food per person.We do not accept reservations for dessert only. Please note.\nIf more than the number of guests booked on the day of booking, customers may not be able to make a seat. Please note.\nIf it is crowded, you may be allowed to use your seat for up to ● hours. Please note.',
}

export default {
  namespaced: true,
  state: {
    contents: null,
    lang: null,
    busy: false,
  },
  mutations: {
    set(state, value) {
      state.lang = value.lang
      state.contents = value.contents
    },
    update(state, contents) {
      state.contents = contents
    },
    busy(state, busy) {
      state.busy = busy
    },
  },
  actions: {
    get(store, lang) {
      const { commit, rootState } = store
      commit('set', { lang, contents: rootState.reception.tos[lang] || DEFAULT_TOS[lang] })
    },
    async save(store) {
      const { commit, state } = store
      if (state.busy) return false
      commit('busy', true)

      const payload = { tos: { [state.lang]: state.contents } }

      const { status, message } = await POST('/api/web/reception/tos/update', payload)

      if (status === 200) {
        commit('reception/tos/set', payload, { root: true })
      } else {
        commit('app/error', { status, message }, { root: true })
      }

      commit('busy', false)
      return status === 200
    },
  },
}
